// CSV and TSV for the Files viewer: RFC 4180 quoting (quotes, doubled quotes,
// separators and newlines inside quotes), capped rows. Pure; csv.test.ts.

export interface Table {
  rows: string[][]
  /** rows past the cap that were not parsed into the table */
  more: boolean
  columns: number
}

/** Which separator a file uses: its extension says, else whichever of tab, comma and semicolon leads the first line. */
export const separatorFor = (name: string, text: string): string => {
  if (name.toLowerCase().endsWith('.tsv')) return '\t'
  const first = text.slice(0, text.indexOf('\n') >= 0 ? text.indexOf('\n') : text.length)
  const count = (c: string) => first.split(c).length - 1
  const best = ['\t', ',', ';'].sort((a, b) => count(b) - count(a))[0]!
  return count(best) > 0 ? best : ','
}

export const parseDelimited = (text: string, sep = ',', maxRows = 500): Table => {
  const rows: string[][] = []
  let row: string[] = []
  let cell = ''
  let quoted = false
  let i = 0
  const s = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text
  const endRow = () => {
    row.push(cell)
    cell = ''
    if (!(row.length === 1 && row[0] === '')) rows.push(row)
    row = []
  }
  while (i < s.length) {
    const c = s[i]!
    if (quoted) {
      if (c === '"') {
        if (s[i + 1] === '"') {
          cell += '"'
          i += 2
          continue
        }
        quoted = false
        i++
        continue
      }
      cell += c
      i++
      continue
    }
    if (c === '"' && cell === '') {
      quoted = true
      i++
    } else if (c === sep) {
      row.push(cell)
      cell = ''
      i++
    } else if (c === '\n' || c === '\r') {
      endRow()
      if (c === '\r' && s[i + 1] === '\n') i++
      i++
      if (rows.length >= maxRows) return { rows, more: i < s.length, columns: width(rows) }
    } else {
      cell += c
      i++
    }
  }
  if (cell !== '' || row.length) endRow()
  return { rows, more: false, columns: width(rows) }
}

const width = (rows: string[][]) => rows.reduce((m, r) => Math.max(m, r.length), 0)
